export const isPage = (pathnames: string[]) =>
  pathnames.some(path => window.location.pathname.includes(path));

// Only Alitu properties over https, or localhost for development. `host` keeps
// any non-default port, so ports are rejected. Checking the scheme also blocks
// `javascript://app.alitu.com/%0A...`, whose host would otherwise pass.
export const isAllowedRedirectUrl = (url: string) => {
  try {
    const { host, protocol } = new URL(url);
    if (host === 'localhost') return protocol === 'http:' || protocol === 'https:';
    return protocol === 'https:' && (host === 'alitu.com' || host.endsWith('.alitu.com'));
  } catch {
    return false;
  }
};
